import React from 'react';
import DynamicText from './DynamicText';

const Title = (props) => {
    const { item, children, className } = props;
    const { titleType, settings = {}, dynamicText = {} } = item;
    const { items, options: dynamicTextOptions = {} } = dynamicText;
    let options = {},
        TagName = titleType,
        dynamic = settings.dynamicText?._enabled;

    // transfor value from string to number to pass typedjs
    Object.entries(dynamicTextOptions).forEach(([key, value]) => {
        if (typeof value === 'string') {
            options[key] = +value;
        } else if (key === 'cursorChar') {
            options[key] = value ? '|' : '';
        } else {
            options[key] = value;
        }
    });

    return (
        <TagName className={`dorik-heading ${className}`}>
            <span dangerouslySetInnerHTML={{ __html: children }} />
            {dynamic && items.length > 0 && (
                <DynamicText items={items} typedOptions={options} />
            )}
        </TagName>
    );
};

export default Title;
